export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: "cat-1",
    name: "色彩理论",
    slug: "color-theory",
    description: "深入理解色彩的本质，从色轮基础到高级色彩心理学，掌握色彩的科学规律与艺术表达。",
    icon: "ri-palette-line",
    articleCount: 6,
  },
  {
    id: "cat-2",
    name: "配色方案",
    slug: "color-schemes",
    description: "探索经典与创新的配色组合，从互补色到分裂补色，找到最适合你项目的色彩搭配方案。",
    icon: "ri-contrast-drop-line",
    articleCount: 5,
  },
  {
    id: "cat-3",
    name: "设计灵感",
    slug: "design-inspiration",
    description: "汇聚全球优秀设计案例，从自然、建筑、艺术中汲取色彩灵感，激发你的创作潜能。",
    icon: "ri-lightbulb-flash-line",
    articleCount: 5,
  },
  {
    id: "cat-4",
    name: "视觉美学",
    slug: "visual-aesthetics",
    description: "探讨色彩与视觉美学的关系，学习如何用色彩构建和谐、有感染力的视觉体验。",
    icon: "ri-eye-line",
    articleCount: 4,
  },
  {
    id: "cat-5",
    name: "创意工具",
    slug: "creative-tools",
    description: "推荐实用的配色工具与资源，从在线调色板到色彩分析工具，提升你的设计效率。",
    icon: "ri-tools-line",
    articleCount: 4,
  },
];